import { DecayCalibrationType } from '@models/decay/decay-calibration-type';
import { CURRENCY_FORMATTER, NUMBER_FORMATTER_NO_DECIMALS } from '@shared/spread/spread-settings';

export const getDecayCalibrationTypeSettings = (type: number) => {
  switch (type) {
    case DecayCalibrationType.AvgVintageBalance:
      return {
        title: 'Average Vintage Balance',
        dataFormatter: CURRENCY_FORMATTER,
        chartUnit: {
          title: {
            text: 'USD $'
          },
          labels: {
            format: '${value:,.0f}'
          }
        }
      };
    case DecayCalibrationType.AvgOpenAccounts:
      return {
        title: `Average Open Accounts`,
        dataFormatter: NUMBER_FORMATTER_NO_DECIMALS,
        chartUnit: {
          title: {
            text: 'Open Accounts'
          }
        }
      };
    default:
      return {
        title: `Average Vintage Value`,
        dataFormatter: NUMBER_FORMATTER_NO_DECIMALS
      };
  }
};
